// @todo: Refactor to constants when API will be ready
const chargesListFields = [
    {
      field: 'id',
      title: 'Id',
      hidden: true,
    },
    {
      field: 'expenseAccountId',
      title: 'expenseAccountId',
      hidden: true,
    },
		// {
		// 	field: 'commands',
		// 	title: 'Actions',
		// 	cell: 'commands',
		// 	sortable: false,
		// 	locked: true,
		// 	hidden: false,
		// 	width: 80,
		// },
    {
      title: 'Type',
      field: 'accountName',
      cell: 'navigation',
    },
    {
      title: 'Description',
      field: 'description',
    },
    
    {
      title: 'Vendor Charge',
      cell: 'invertedCheckMark',
      field: 'isInHouseExpense',
    },
    {
      title: 'In-House',
      cell: 'checkMark',
      field: 'isInHouseExpense',
    },
    {
      title: 'Amount',
      field: 'amount',
      cell: 'formatAmount'
    },
    {
      field: 'deletecommands',
      title: '',
      cell: 'deletecommands',
      headerCell: 'commandsHeader',
      sortable: false,
      hidden: false,
      locked: true,
      width: 30,
    },
  ];

  export default chargesListFields;